import React, { PureComponent } from "react";
import { ICSSProps, ICSS } from "@gago/frame";
import styled from "styled-components";
import { isEqual, uniqueId } from "lodash";
// tslint:disable:variable-name ter-max-len completed-docs jsx-no-multiline-js
const PlayerBody = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;
type Cprops = {
  /** URL参数 */
  url: string;
  /** 是否自动播放 */
  autoPlay: boolean;
  /** 带有预览图（海报图片）的视频 */
  poster?: string;
} & ICSSProps;

/**
 * 视频播放 使用百度云播放器
 * @see http://cyberplayer.bcelive.com/demo/new/index.html
 * @author 马俊峰
 * @date 2020-08-04
 * @export
 * @class Player
 * @extends {PureComponent<Cprops>}
 * @implements {ICSS}
 */
export class Player extends PureComponent<Cprops> implements ICSS {
  palyerId: string = uniqueId("player_");
  player: any | null = null;
  static defaultProps = {
    autoPlay: true,
  };
  /** 初始化video */
  initVideo = () => {
    const { url, autoPlay, poster } = this.props;
    this.player = window.cyberplayer(this.palyerId).setup({
      width: "100%",
      height: "100%",
      file: url, // <—rtmp直播地址
      image: poster,
      autostart: autoPlay,
      type: "mp4",
      // type: "{mp4 | flv | m3u8 | rtmp}",
      startParam : "start",
      stretching: "exactfit",
      volume: 0,
      controls: true,
      rtmp: {
        reconnecttime: 5, // rtmp直播的重连次数
        bufferlength: 1, // 缓冲多少秒之后开始播放 默认1秒
      },
      skin: {
        name: "bce", // 默认皮肤-bce，其他可选项有beelden, bekle, five, glow, roundster, seven, six, stormtrooper, vapor 需要引入指定的css
        background: "#000", // 背景色设置
        inactive: "#FFF", // 未激活时的颜色
        active: "red", // 悬浮或激活的严责
      },
      ak: "26d8fb5253dd492ba9fce986a31fdeae", // 公有云平台注册即可获得accessKey
      controlbar: { barLogo: false },
    });
  }
  componentDidMount() {
    this.initVideo();
  }
  componentDidUpdate(preProps: Cprops) {
    if (!isEqual(preProps, this.props)) {
      this.initVideo();
    }
  }
  componentWillUnmount() {
    this.disposePlayer();
  }
  /** 销毁播放器 */
  disposePlayer = () => {
    this.player && this.player.remove();
  }
  render() {
    const { style, className } = this.props;
    return(
      <PlayerBody
        id={this.palyerId}
        style={style}
        className={className}
      />
    );
  }
}
